<template>
  <v-sheet>
    <v-card class="ma-4 pa-6">
      <v-card-title class="text-h5">📘 About This System</v-card-title>
      <v-card-text>
        <p>
          This is a modern Event Management System built with Vue.js, Vuetify,
          Node.js, and MySQL. It allows organizers to manage events, track
          attendees, and monitor check-ins in real-time.
        </p>

        <ul>
          <li>🎯 Create and manage events</li>
          <li>👥 Add and edit attendees</li>
          <li>✅ Track check-ins with QR codes</li>
          <li>📊 View live statistics and event performance</li>
        </ul>

        <p>
          Designed for efficiency and scalability, this platform helps ensure
          your events run smoothly. For support or contributions, contact
          <a href="mailto:contact@bachirsouldi.com"></a>.
        </p>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>
